"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Link_1 = __importDefault(require("../Link"));
var MobileLink = (0, styled_1.default)(Link_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        textAlign: 'center',
        paddingTop: theme.space[3],
        paddingBottom: theme.space[3],
    });
});
var MobileMenuGroup = function (props) {
    var menuSet = props.menuSet, isLoggedIn = props.isLoggedIn;
    return (react_1.default.createElement(react_1.default.Fragment, null, menuSet === null || menuSet === void 0 ? void 0 : menuSet.map(function (item) { return (react_1.default.createElement(MobileLink, { key: item.url, href: item.url, "data-event-location": "header_menu", "data-event-label": item.label }, (isLoggedIn && item.loggedInLabel) ? item.loggedInLabel : item.label)); })));
};
exports.default = MobileMenuGroup;
